import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { checkSession } from "./utils/session";
import Splash from "./components/Splash";
import Navbar from "./components/Navbar";
import httpRequest from "./utils/api";
import Message from "./components/Message";
import Modal from "./components/Modal";
import Menu from "./components/Menu";
import SnackBar from "./components/SnackBar";
import { permissions } from "./utils/permissions";
import NotificationsPanel from "./components/NotificationsPanel";
import { deleteCookie,getCookie } from "./utils/cookie";
import BottomPanel from "./components/BottomPanel";
import {
  get_message_list,
  get_user_pv,
  heartbeat,
  pv_codice_gestore,
  user_progress,
} from "./utils/endpoints";
import Footer from "./components/Footer";
import ProfilePanel from "./components/ProfilePanel";
import Spinner from "./components/Spinner";
import PillsLoader from "./components/PillsLoader";
import { useMsal } from "@azure/msal-react";

export default function Layout() {
  const navigate = useNavigate();
  const [splash, setSplash] = useState(<Splash />);
  const [message, setMessage] = useState();
  const [modal, setModal] = useState();
  const [bottom_panel, setBottomPanel] = useState();
  const [menu, setMenu] = useState();
  const [profile_panel, setProfilePanel] = useState();
  const [notifications_panel, setNotificationsPanel] = useState();
  const [is_online, setIsOnline] = useState(navigator.onLine);
  const [is_first_load, setIsFirstLoad] = useState(true);
  const [notifications, setNotifications] = useState();
  const [notification_interval_started, setNotificationIntervalStarted] =
    useState(false);

  const location = useLocation();
  const { instance, inProgress, accounts } = useMsal();

  /*context method for open message globally*/
  const openMessage = (type, message) => {
    setMessage(<Message type={type} message={message} />);
  };

  /*context method for open modal globally*/
  const openBottomPanel = (content, header_close = true) => {
    setBottomPanel(
      <BottomPanel
        content={content}
        closePanel={() => setBottomPanel()}
        header_close={header_close}
      />
    );
  };

  /*context method for open modal globally*/
  const openModal = (content, header_close = true) => {
    setModal(
      <Modal
        content={content}
        closeModal={() => setModal()}
        header_close={header_close}
      />
    );
  };

  /*context method for open menu globally*/
  const openMenu = (current_context) => {
    setMenu(
      <Menu
        context={current_context}
        updateContext={updateContext}
        closeMenu={() => setMenu()}
      />
    );
  };

  /*context method for open profile panel globally*/
  const openProfilePanel = (current_context) => {
    setProfilePanel(
      <ProfilePanel
        context={current_context}
        updateContext={updateContext}
        closeProfilePanel={() => setProfilePanel()}
      />
    );
  };

  /*context method for open menu globally*/
  const openNotifications = (current_context, notifications_list) => {
    setNotificationsPanel(
      <NotificationsPanel
        context={current_context}
        closeNotification={() => setNotificationsPanel()}
        notifications={notifications_list}
      />
    );
  };

  /*context method for open splash panel globally*/
  const openSplash = () => {
    setSplash(<Splash />);
  };

  /*context method for update user progress*/
  const updateUserProgress = async (current_context) => {
    if (current_context.session) {
      let response = await current_context.httpRequest(
        "get",
        user_progress,
        null,
        current_context.session.token
      );
      if (response.result) updateContext({ progress: response.data });
    }
  };

  /*method for merge old context with new context state*/
  const updateContext = (new_context) => {
    setContext((prev_context) => {
      return { ...prev_context, ...new_context };
    });
  };

  /*update notifications list*/
  const updateNotifications = async (current_context, need_result = false) => {
    const response = await current_context.httpRequest(
      "get",
      get_message_list,
      null,
      current_context.session.token
    );
    if (response.result) {
      setNotifications(response.data);
      if (need_result) return response.data;
    }
  };

  /*middleware method of http request*/
  const requestFetch = async (
    method,
    url,
    params = null,
    token = null,
    session_checking = false,
  ) => {
    return await httpRequest(
      context,
      updateContext,
      navigate,
      requestFetch,
      method,
      url,
      params,
      token,
      session_checking
    );
  };
  const handleLogOut = (context) => {
    if (context?.is_active_directory) {
      deleteCookie("is_active_directory");
      instance.logoutPopup();
    }
    else
    {
      localStorage.removeItem("last_container_viewed");
      deleteCookie("session_cookie");
      deleteCookie("pv_impersonate");
      updateContext({
        session: null,
        progress: null,
        pv_list: null,
        is_active_directory: false,
      });
      navigate("/login");
      }
  };
  /*global application context (core state)*/
  const [context, setContext] = useState({
    is_active_directory: false,
    session: null,
    progress: null,
    pv_list: null,
    device: "mb",
    loader: false,
    loader_pills: false,
    browser: null,
    httpRequest: requestFetch,
    navigateUrl: navigate,
    openMessage: openMessage,
    openModal: openModal,
    openBottomPanel: openBottomPanel,
    openMenu: openMenu,
    openProfilePanel: openProfilePanel,
    openNotifications: openNotifications,
    openSplash: openSplash,
    updateUserProgress: updateUserProgress,
    updateNotifications: updateNotifications,
    handleLogOut:handleLogOut
  });



  /*check the session expired from moodle iframe message*/
  window.onmessage = function (e) {
    if (e.origin !== process.env.REACT_APP_DOMAIN) return;
    else if (e?.data?.session_expired) {
      handleLogOut();
    }
  };

  /*background color change on scroll*/
  const handleScroll = () => {
    let position = window.scrollY;
    let navbar = document.querySelector("#navbar");
    let search_on_page = document.querySelector("#search-on-page");
    let pv_list_banner = document.querySelector("#pv-list-banner");
    if (position > 0) {
      document.body.style.background = "#20419a";
      navbar.style.background = "#20419a";
      if (search_on_page) search_on_page.style.background = "#20419a";
      if (pv_list_banner) pv_list_banner.style.background = "#20419a";
    } else {
      document.body.style.background = "initial";
      navbar.style.background = "initial";
      if (search_on_page) search_on_page.style.background = "initial";
      if (pv_list_banner) pv_list_banner.style.background = "initial";
    }
  };

  /*check browser and device info*/
  const checkNavigationInfo = () => {
    let info_obj = { device: null, browser: null };

    info_obj.device = window.matchMedia("(max-width: 992px)").matches
      ? "mb"
      : "dk";

    let browser = (function () {
      var checkBrowser = function (regexp) {
        return regexp.test(window.navigator.userAgent);
      };
      switch (true) {
        case checkBrowser(/edg/i):
          return "edge";
        case checkBrowser(/trident/i):
          return "ie";
        case checkBrowser(/firefox|fxios/i):
          return "firefox";
        case checkBrowser(/opr\//i):
          return "opera";
        case checkBrowser(/ucbrowser/i):
          return "uc";
        case checkBrowser(/samsungbrowser/i):
          return "samsung";
        case checkBrowser(/chrome|chromium|crios/i):
          return "chrome";
        case checkBrowser(/safari/i):
          return "safari";
        default:
          return null;
      }
    })();
    info_obj.browser = browser;

    updateContext(info_obj);
  };
  const restoreSession = async (msalInstance,accounts) => {
  
    const isAuthenticated = getCookie("is_active_directory") === "true";
  
     // Controlla se ci sono account nella cache di MSAL
     const accountsMsal = msalInstance.getAllAccounts();
     if (accountsMsal.length > 0) {
       console.log("Sessione AD già attiva");
       return;
     }     
    if (isAuthenticated && accounts.length ==0 ) {

      console.log("Nessun account trovato, forzando il login.");
      await msalInstance.handleRedirectPromise(); // Ripristina sessione dal redirect
      const refreshedAccounts = msalInstance.getAllAccounts();
      if (refreshedAccounts.length === 0) {
        console.log("Nessun account ripristinato. Eseguo il login.");
        deleteCookie("is_active_directory");  
        
      } else {
        console.log("Sessione AD ripristinata con successo:");
        
      } 
      checkSession(updateContext, navigate, requestFetch, msalInstance, refreshedAccounts);     
    }
  };
  // useEffect(() => {
  //   if (instance && inProgress === "none" && accounts.length ==0 )
  //     restoreSession(instance,accounts);
  // }, [inProgress,instance,accounts]);
  /*check initial session and redirect (first load)*/
  useEffect(() => {
    if (inProgress === "none" && accounts && instance) {      
      checkSession(updateContext, navigate, requestFetch, instance, accounts);
      setIsFirstLoad(false);
      checkNavigationInfo();
    }    
  }, [instance, inProgress, accounts]);

  /*check permission on change page (not for first load)*/
  useEffect(() => {
    window.scrollTo(0, 0);
    window.onbeforeunload = function () {};

    if (context && context?.session)
      requestFetch("get", heartbeat, null, context.session.token);

    const current_path =
      permissions.find((x) => x.href === location.pathname) ||
      permissions.find((x) => x.is_index);    
    if (current_path) {
      if (!is_first_load) {
        if (!current_path.permission.includes("ALL")) {
          if (context && context.session) {
            if (
              !current_path.permission.includes(context.session.profileTypeCode)
            ) {
              if (current_path.redirect_session)
                context.navigateUrl(current_path.redirect_session);
              else context.navigateUrl("/");
            }
          } else {
            const isAuthenticatedWithAD = getCookie("is_active_directory") === "true";
            if (!isAuthenticatedWithAD)
            {
              handleLogOut();
            }              
          }
        }
      }
    }
  }, [location]);

  /*remove background change on scroll event over mobile device*/
  useEffect(() => {
    if (context.device === "mb")
      document.addEventListener("scroll", handleScroll);
    else {
      document.addEventListener(
        "scroll",
        (e) => {
          e.stopImmediatePropagation();
        },
        true
      );
    }
  }, [context.device]);

  /*update notifications each 3 minutes*/
  useEffect(() => {
    if (context.session) {
      updateNotifications(context);

      if (!notification_interval_started) {
        setNotificationIntervalStarted(true);
        setInterval(() => {
          if (context.session) updateNotifications(context);
        }, 60000 * 3);
      }

      (async () => {
        let response_user_pv = await context.httpRequest(
          "get",
          `${get_user_pv}?email=${context.session?.email}`,
          null,
          context.session.token
        );
        if (response_user_pv?.result && response_user_pv?.data) {
          if (
            response_user_pv.data[0] &&
            response_user_pv.data[0]?.codiceCliente
          ) {
            let response_pv = await context.httpRequest(
              "get",
              pv_codice_gestore.replace("*",response_user_pv.data[0].codiceCliente),
              null,context.session.token
            );
            if (response_pv?.result && response_pv?.data)
              updateContext({ pv_list: response_pv.data.puntiVendita });
          }
        }
      })();
      const container_id = localStorage.getItem("last_container_viewed");
      if (container_id !== null) {
        context.navigateUrl(`/pills-list?container=${container_id}`);
      }
    }
  }, [context.session]);

  /*check connection status in real time*/
  useEffect(() => {
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };
    window.addEventListener("online", handleStatusChange);
    window.addEventListener("offline", handleStatusChange);
    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, [is_online]);

  /*close splash panel after 3 seconds*/
  useEffect(() => {
    if (splash) {
      setTimeout(() => {
        setSplash();
      }, 3000);
    }
  }, [splash]);

  /*close message after 3 seconds*/
  useEffect(() => {
    if (message) {
      setTimeout(() => {
        setMessage();
      }, 5000);
    }
  }, [message]);

  return (
    <>
      {location.pathname !== "/sso/authorize" ? (
        <Navbar context={context} notifications={notifications} />
      ) : null}
      <Outlet context={[context, updateContext]} />
      {splash}
      {message}
      {modal}
      {bottom_panel}
      {menu}
      {profile_panel}
      {notifications_panel}
      {!is_online ? (
        <SnackBar
          type="danger"
          message="In attesa di connessione"
          loading={true}
        />
      ) : null}
      <Footer />
      {context.loader ? <Spinner /> : null}
      {context.loader_pills ? <PillsLoader /> : null}
    </>
  );
}
